import { Card } from 'src/components/data-display/card';
import { PageHeader } from 'src/components/layout/page-header';
import { Link } from 'src/components/navigation/link';

export const SnamBiddingSuccessPage = () => {
  return (
    <div
      className={`
        grid items-center gap-md
        legacy:gap-[1rem]
      `}
    >
      <PageHeader title="Gela and Mazara (SNAM) Auctions" />

      <Card>
        <div
          className={`
            grid items-center gap-xl
            legacy:gap-[2rem]
          `}
        >
          <p>
            We have placed your bid. In the next few minutes you should receive
            a confirmation email.
          </p>

          <div className="grid grid-flow-col items-center justify-items-end">
            <Link mode="button-primary" to="/">
              Back to Homepage
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
};
